import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_83jaocy6: FaireBrandEntity = {
  token: "b_83jaocy6",
  type: "brand",
  name: "Harlem Candle Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/4359dc454458f0779ccedf14430c7fe720330f69d3f09c7a0d7f628f3330de4e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c58b9cff77b27e8387ece3bad0e8b61cda0c8660a465f1c4827e77b761c040e3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4359dc454458f0779ccedf14430c7fe720330f69d3f09c7a0d7f628f3330de4e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c58b9cff77b27e8387ece3bad0e8b61cda0c8660a465f1c4827e77b761c040e3.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 45,
  isTopShop: true,
  isInsider: true,
  description:
    "The Harlem Candle Co is a luxury home fragrance brand specializing in scented candles inspired by the richness of Harlem. Founded in 2014 by travel and lifestyle expert Teri Johnson, the Harlem Candle Company is the manifestation of her love affair with fragrance, jazz, and Harlem.  As a child, Teri fell in love with her favorite aunt's collection of exotic perfumes and travel stories, planting the seed for her own relationship with travel and fragrances. Throughout her journeys to 70 countries, Teri has experienced the power of scent and its ability to transport you.  Music icons including Billie Holiday and Duke Ellington who performed at clubs such as the Savoy Ballroom and the colorful areas of Harlem’s Sugar Hill and Lenox Avenue have all inspired her to share these stories through a unique collection of luxurious home fragrances.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:54.439Z",
    importedBy: "entity-db-cli",
  },
};
